import { Address } from 'viem';

export const usdcTokenAddress: Address = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48';
